import React from 'react';

import Loader from '@components/loader/Loader';
import CloseIcon from '@mui/icons-material/Close';
import { Drawer, IconButton } from '@mui/material';
import { MAIN_THEME } from '@styles';

import DynamicFormWidget from './DynamicFormWidget';
import { useDynamicFormDrawerStyles } from './style';
import { IDynamicFormDrawer } from './types';

const DynamicFormDrawer: React.FC<IDynamicFormDrawer> = (props) => {
  const { title, loading, isOpen, onClose } = props;
  const { classes } = useDynamicFormDrawerStyles();

  // Prevent any nested form from causing a full page submit
  const preventNativeSubmit: React.FormEventHandler<HTMLDivElement> = (e) => {
    // If a nested <form> bubbles a submit up, stop it here
    if ((e as unknown as React.SyntheticEvent).type === 'submit') {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <Drawer
      open={isOpen}
      anchor="bottom"
      onClose={onClose}
      classes={{ paperAnchorBottom: classes.drawer }}
    >
      <header className={classes.drawerHeader}>
        <figure className={classes.sectionFigure} />
        <span className={classes.drawerHeaderTitle}>{title}</span>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ margin: '0 15px 0 0' }}
        >
          <CloseIcon sx={{ color: MAIN_THEME.color.white }} />
        </IconButton>
      </header>

      {loading ? (
        <div className={classes.loaderContainer}>
          <Loader />
        </div>
      ) : (
        // Catch any bubbling submit from inside the drawer
        <div onSubmit={preventNativeSubmit}>
          <DynamicFormWidget {...props} />
        </div>
      )}
    </Drawer>
  );
};

export default DynamicFormDrawer;
